import React, { useEffect, useState } from 'react';
import Rutas from '../../routes/Routes';
import Notifications from '../../insfrastructure/ui/notify';
import { useApp } from '../../context/AppContext';
import LayoutComponent from '../../insfrastructure/ui/layout';
import Menu from './menu'
import navbarMenus from './navbar_menu';
import './style.css';
 

const Layout = (props) => {
    const { loadMain } = useApp();
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => { 
        loadMain();
    }, [loadMain]);

    const rightSidebarContent = (
        <div>
            <h3>Herramientas</h3>
            <p>Esta es la barra de herramientas.</p>
        </div>
    );

    return (
        <>
            <LayoutComponent
                sidebarMenus={Menu}
                navbarMenus={navbarMenus}
                rightSidebarContent={rightSidebarContent}
            >
                <Rutas />
            </LayoutComponent>
            <Notifications />
        </>
    )
}

export default Layout;

